import React from "react";
import Account from "../../../VirtualAccount/components/Account";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/hooks";
import { formatCurrencyAmount } from "../../../../utils/currency";
import SettlementTransactionsTable from "../../components/SettlementTransactionsTable";

const toolTipText = "Your settlement balance reflects the total amount that has been settled to your account."

export default function IndividualSettlementAccount() {

    const { currencyCode } = useParams<{ currencyCode: string }>();
    const capitalizedCurrencyCode = currencyCode?.toUpperCase() || "";

    const { wallets } = useAppSelector(
        (state) => state.wallets,
    );

    const settlementAccountOfInterest = wallets.find(
        (curr) => curr?.currency === capitalizedCurrencyCode,
    );


    return (
        <div>
            <Account
                title={`${capitalizedCurrencyCode} Settlement balance`}
                isSettlementFlow
                balance={formatCurrencyAmount(
                    capitalizedCurrencyCode,
                    settlementAccountOfInterest?.settlementBalance ?? 0,
                )}
                tooltipText={toolTipText}
                currency={currencyCode}
            />

            <SettlementTransactionsTable currencyOfInterest={capitalizedCurrencyCode} />
        </div>
    )
}